export default {"src":"/_next/static/media/play.2bb9bc5e.svg","height":18,"width":16};